export default "__VITE_PUBLIC_ASSET__def68972__"